import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { GithubService } from '../../service';

export type FileSyncConfig = typeof FileSyncConfig._.Config;

export const FileSyncConfig = IntegrationConfig.make({
  service: GithubService,
  name: Integration_Handler_Names_Enum.FileSync,
  configSchema: z.object({
    repositoryName: z.string().min(1),
    ref: z.string().optional(), // The name of the commit/branch/tag. Default: the repository’s default branch.
    path: z.string().min(1),
  }),
});
